function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#252C32"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.893 2.223v11.272c1.936.526 3.28 2.284 3.28 4.29 0 2.007-1.344 3.765-3.28 4.292v11.271H6.67V22.077c-1.937-.527-3.28-2.285-3.28-4.291 0-2.007 1.343-3.765 3.28-4.291V2.223h2.223zm10.004 0v20.165c1.937.526 3.28 2.284 3.28 4.29 0 2.007-1.343 3.765-3.28 4.291v2.38h-2.223v-2.38c-1.936-.526-3.28-2.284-3.28-4.29 0-2.007 1.344-3.765 3.28-4.291V2.223h2.223zm10.005 0v2.38c1.958.505 3.328 2.268 3.335 4.29-.007 2.022-1.377 3.785-3.335 4.29v20.165h-2.223V13.184c-1.937-.527-3.28-2.285-3.28-4.291 0-2.007 1.343-3.765 3.28-4.29v-2.38h2.223zM17.786 24.455c-1.228 0-2.224.996-2.224 2.224 0 1.227.996 2.223 2.224 2.223 1.228 0 2.223-.996 2.223-2.223 0-1.228-.995-2.224-2.223-2.224zM7.78 15.563c-1.228 0-2.223.995-2.223 2.223 0 1.228.995 2.223 2.223 2.223 1.228 0 2.223-.995 2.223-2.223 0-1.228-.995-2.224-2.223-2.224zm20.01-8.893c-1.229 0-2.224.995-2.224 2.223 0 1.228.995 2.223 2.223 2.223.59 0 1.155-.234 1.572-.651.417-.417.651-.983.651-1.572 0-1.228-.995-2.223-2.223-2.223z",
  transform: "translate(-368 -2593) translate(368.429 2593)"
}))));

var SvgAdjustments = function SvgAdjustments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdjustments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adjustments.99189e3e.svg";
export { ForwardRef as ReactComponent };